'use client';

import { c as _c } from "react/compiler-runtime";
import { PopoverGroup } from '@headlessui/react';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { Button } from '@/frontend/design-system/actions/Button';
import { Link } from '@/frontend/design-system/actions/Link';
import { AboutUs } from '../_sections/AboutUs';
import { CoursesSection } from '../_sections/Courses';
import { ManageSiteSection } from '../_sections/ManageSite';
import { MentoringSection } from '../_sections/Mentoring';
export function NavbarDesktop(t0) {
  const $ = _c(11);
  const {
    canManageSite
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AboutUs />;
    t2 = <MentoringSection />;
    t3 = <CoursesSection />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Link href="/kontakt"><span className="font-medium text-slate-900 text-sm hover:text-algosecondary hover:underline">Kontakt</span></Link>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Link href="/baza"><span className="flex items-center gap-x-1 text-center font-medium text-algoprimary text-sm hover:underline">Baza wiedzy<ArrowRightIcon className="h-3 w-3 shrink-0" /></span></Link>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className="mt-0.5 flex items-center gap-8">{t5}<Link href="/app"><span className="flex items-center gap-x-1 font-medium text-algoprimary text-sm hover:underline">Aplikacja<ArrowRightIcon className="h-3 w-3" /></span></Link></section>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== canManageSite) {
    t7 = canManageSite && <ManageSiteSection />;
    $[6] = canManageSite;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Button href="/bezplatna-konsultacja" className="text-nowrap">Umów spotkanie</Button>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7) {
    t9 = <PopoverGroup className="hidden items-center lg:flex lg:gap-x-8">{t1}{t2}{t3}{t4}{t6}{t7}{t8}</PopoverGroup>;
    $[9] = t7;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}